<template>
  <div
    :class="{
      'ant-table-cell-ellipsis': column.ellipsis,
      tr: alignTr,
    }"
    class="format-cell"
  >
    <template v-if="checkIsArray(formatCell)">
      <template v-for="(item, index) in formatCell">
        <span>
          <span v-if="item.type === '01'">{{
            formatText(item.text, column.columnType, column.optionValueList)
          }}</span>
          <span v-else-if="item.type === '02'">
            <router-link :to="item.path">{{
              formatText(item.text, column.columnType, column.optionValueList)
            }}</router-link>
          </span>
          <span v-else-if="item.type === '03'">
            <a :href="item.path" target="_blank">{{
              formatText(item.text, column.columnType, column.optionValueList)
            }}</a>
          </span>
          <span v-if="index + 1 < formatCell.length">、</span>
        </span>
      </template>
    </template>
    <template v-else>
      <span v-if="formatCell.type === '01'">{{
        formatText(formatCell.text, column.columnType, column.optionValueList)
      }}</span>
      <span v-else-if="formatCell.type === '02'">
        <router-link :to="formatCell.path">{{
          formatText(formatCell.text, column.columnType, column.optionValueList)
        }}</router-link>
      </span>
      <span v-else-if="formatCell.type === '03'">
        <a :href="formatCell.path" target="_blank">{{
          formatText(formatCell.text, column.columnType, column.optionValueList)
        }}</a>
      </span>
    </template>
  </div>
</template>
<script>
import { computed } from '@vue/runtime-core'
import { safeJsonParse } from '@/utils/utils'
export default {
  props: {
    text: {},
    column: {
      type: Object,
      default: () => {},
    },
    addMark: {
      default: false,
    },
  },
  setup(props) {
    const formatCell = computed(() => {
      const text = props.text
      const column = props.column
      // 01：纯文本 02：route-link 03：a标签
      if (column.hasLink) {
        if (text === null || text === undefined || text === '') {
          return {
            text: '',
            type: '01',
            path: '',
          }
        }
        try {
          const obj = safeJsonParse(text)
          if (column.columnType === '14') {
            const arr = []
            obj.forEach((item) => {
              arr.push(formatCellLinkCreator(item))
            })
            return arr
          } else {
            return formatCellLinkCreator(obj)
          }
        } catch (error) {
          return {
            text: text,
            type: '01',
            path: '',
          }
        }
      } else if (column.optionValueList) {
        const optionValueList = column.optionValueList
        let newText = ''
        if (typeof text !== 'undefined' && text !== null && text !== '') {
          try {
            const valueArr = String(text).indexOf(',') > 0 ? String(text).split(',') : String(text).split(';')
            // 通过 value 数组过滤对象数组，获取符合条件的对象
            let result = optionValueList.filter((obj) => {
              if (typeof text === 'boolean') {
                if (text) {
                  return obj.value === '1'
                } else {
                  return obj.value === '0'
                }
              } else {
                return valueArr.includes(obj.value)
              }
            })

            // 通过 map 方法获取符合条件的对象的 title 属性值
            result = result.map((obj) => obj.title)
            newText = result.join('、')
          } catch (error) {
            console.warn(error)
          }
        }

        // const option = optionValueList.find(
        //   (option) => option.value === String(text)
        // )
        return {
          text: newText ? newText : text,
          type: '01',
          path: '',
        }
      } else {
        return {
          text: text === null ? '' : text,
          type: '01',
          path: '',
        }
      }
    })
    const formatText = (text, columnType, optionValueList) => {
      if (text === undefined || text === null) {
        return ''
      }
      if (typeof text === 'boolean' && !optionValueList) {
        if (text) {
          return '〇'
        } else {
          return ''
        }
      }
      const formatter = new Intl.NumberFormat('ja-JP')
      switch (columnType) {
        case '01':
          let formatN = formatter.format(text)
          if (props.addMark && Math.abs(text) > 10000) {
            formatN = '￥' + formatN
          }

          return formatN
        case '13':
          return `${text}%`

        default:
          return text
      }
    }
    const alignTr = computed(() => {
      switch (props.column.columnType) {
        case '01':
        case '13':
          return true

        default:
          return false
      }
    })

    const formatCellLinkCreator = (obj) => {
      if (obj.link) {
        if (obj.link_is_blank) {
          return {
            text: obj.title,
            type: '03',
            path: obj.link,
          }
        } else {
          return {
            text: obj.title,
            type: '02',
            path: obj.link,
          }
        }
      } else {
        return {
          text: obj.title,
          type: '01',
          path: '',
        }
      }
    }
    const checkIsArray = (obj) => {
      return Array.isArray(obj)
    }
    return {
      formatCell,
      formatText,
      alignTr,
      checkIsArray,
    }
  },
}
</script>
<style></style>
